import axios from 'axios'
import {
  LaundryBatchModel,
  filterLaundryBatchModel,
  ResponseCRUD,
  ResponseObject,
  batchStartProcessWashModel,
  ResponseObjectPaginated,
  LaundryBatchModelById,
  batchCreateObsModel,
  filterOrdersWithoutObservation,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL

// VISTA GENERAR ORDEN POR LOTE -------------------------------------------------------------------
export function getLaundryGenerateBatch(dto: filterLaundryBatchModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryBatchModel[]>>(
    `${BASEURL}/orderLote/getAllOrden/${page}?size=100`,
    dto,
  )
}
export function startProcessWash(dto: batchStartProcessWashModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/orderLote/createOrderLoteProcessWashing`, dto)
}

export function startProcessOutput(dto: batchStartProcessWashModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/orderLote/createOrderLotProcessOutput`, dto)
}
// VISTA ORDENES GENERADAS  POR LOTE -------------------------------------------------------------------

export function getLaundryBatch(dto: filterLaundryBatchModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryBatchModel[]>>(
    `${BASEURL}/orderLote/getAllOrderLote/${page}`,
    dto,
  )
}

export function getLaundryBatchById(dto: string | undefined, tipoLavado: any) {
  return axios.get<ResponseObject<LaundryBatchModelById>>(
    `${BASEURL}/orderLote/getInformationById?id=${dto}&tipoLavado=${tipoLavado}`,
  )
}

export function getOrdersWithoutObservation(dto: filterOrdersWithoutObservation, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryBatchModel[]>>(
    `${BASEURL}/orderLote/getOrdersWithoutObservation/${page}`,
    dto,
  )
}

export function createLaundryBatchObs(dto: batchCreateObsModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/orderLote/createLotOrderObservation`, dto)
}

export function updateLaundryBatchObs(dto: batchCreateObsModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/orderLote/updateLotOrderObservation`, dto)
}

export function deleteLaundryBatchObs(dto: any, tipoLavado: any) {
  return axios.delete<ResponseCRUD>(
    `${BASEURL}/orderLote/deleteObservationOrderLote?id=${dto}&tipoLavado=${tipoLavado}`,
  )
}

export function releaseObservationsOrder(dto: any) {
  return axios.put<ResponseCRUD>(
    `${BASEURL}/orderLote/releaseObservationsOrder`, dto
  )
}

export function getSupplierBySite() {
  return axios.get<ResponseObject<any>>(`${BASEURL}/orderLote/getAllProveedorBySite`)
}

export function getUserByProfile(text: string) {
  return axios.get<ResponseObject<any>>(`${BASEURL}/orderLote/getAllUsersByFilter?filter=${text}`)
}

export function getEnterpriseByOrder() {
  return axios.get<ResponseObject<any>>(`${BASEURL}/orderLote/getAllEmpresaByOrders`)
}

export function getPointByOrdersLote() {
  return axios.get<ResponseObject<any>>(`${BASEURL}/orderLote/getAllPointsByOrdersLote`)
}

// VISTA ORDEN DE LOTE---------------------------------------------------------

export function startProcessWashBatch(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/orderLote/startProcessWashOrder`, dto)
}
export function endProcessWashBatch(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/orderLote/endProcessWashOrder`, dto)
}
export function endProcessOutputBatch(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/orderLote/endOrderLoteProcessOutput`, dto)
}

export function cancelProcessBatch(id: any, code: any, tipoLavado: any) {
  return axios.delete<ResponseCRUD>(
    `${BASEURL}/orderLote/deleteOrderLote/${id}?motivoCancel=${code}&tipoLavado=${tipoLavado}`,
  )
}
